import { Box, Button, ButtonGroup, Card, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, TextField, Tooltip, Typography , Collapse, Badge, Drawer, Autocomplete, Stack} from '@mui/material'
import React, { useState, useEffect, useCallback } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { DataGrid } from '@mui/x-data-grid'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { clearCachevalue, getCachevalue, localGetItem, localSetItem, setCachevalue } from '../../../../Utility/Services/CacheProviderService'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTime } from 'luxon'
import { appointment_Status_opt, cmt_Char_limit, appointmentSet, sliceSet, Cancel_appointment_Status_opt } from '../../../../Utility/Constants'
import { PovEditPopup, ReasonPopup } from '../../../../Components/Common Components/CommonComponents'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NextAppointments from '../../../FrontOffice/OutPatients/NextAppointments'
import { calculateWaitingTime } from '../../../../Components/CommonFunctions/CommonFunctions'
import { useRef } from 'react';
import { useHistory } from "react-router-dom";
import moment from 'moment'
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function UMADocHome({ CallPatientTrigger, ClearCalledTrigger }) {

    const history = useHistory();
    const [FilterOpen, setFilterOpen] = React.useState(false)
    const [SelectedPatientTags, setSelectedPatientTags] = React.useState([])
    const [patientData, setPatientData] = React.useState([])
    const [page, setpage] = React.useState(0)
    const [pageSize, setpageSize] = React.useState(30)
    const [loading, setloading] = React.useState(false)
    const [message, setMessage] = React.useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [ClinicID, setClinicID] = React.useState(null)
    const [DatePickerOpen, setDatePickerOpen] = React.useState(false)
    const [datePicker, setdatePicker] = React.useState(new Date())
    const [appointmentType, setappointmentType] = React.useState('All')
    const [waitingCmts, setwaitingCmts] = React.useState(false)
    const [SelectedPatientDetails, setSelectedPatientDetails] = React.useState({})
    const [waitCmtText, setwaitCmtText] = React.useState('')
    const [ispovPopOpen, setispovPopOpen] = React.useState(false)
    const [povText, setpovText] = React.useState({})
    const [anchorEl, setanchorEl] = React.useState(null)
    const [selectedRow, setselectedRow] = React.useState(null)
    const [isSelected, setisSelected] = React.useState(false)
    const [remarkText, setremarkText] = React.useState('')
    const [slctMenuOption, setslctMenuOption] = React.useState('')
    const [disableBtn, setdisableBtn] = React.useState(false)
    const [selectedOption, setselectedOption] = React.useState('')
    const [tokenNum, settokenNum] = React.useState('')
    const [isRemarks, setisRemarks] = React.useState(false)
    const [isOPT, setIsOPT] = React.useState(false)
    const [isOptometry, setIsOptometry] = React.useState(false)
    const [DoctorsList, setDoctorsList] = React.useState([])
    const [selectedCard, setselectedCard] = React.useState('')
    const [currentTime, setCurrentTime] = React.useState('')
    const [cancelAppointment, setcancelAppointment] = React.useState(false)
    const [totalAppointment, settotalAppointment] = React.useState({})
    const [isDocOnEmergency, setisDocOnEmergency] = React.useState(false)
    const [isOPTOoutOfOffice, setisOPTOoutOfOffice] = React.useState(true)
    const [patientCount, setpatientCount] = React.useState({})
    const [onAddComment, setonAddComment] = React.useState(false)
    const [onChangePov, setonChangePov] = React.useState(false)
    const logininfo = JSON.parse(localGetItem("loggedInUserInfo"))
    const clinicId = localGetItem("SelectedDoctorClinicId") === 'all' ? 'all' : JSON.parse(localGetItem("SelectedDoctorClinicId"))
    const seldata = JSON.parse(getCachevalue('SelectedDate'))
    const [dataselect, setdataselect] = React.useState(seldata)
    const idclinic = JSON.parse(getCachevalue('SelectedDoctorClinic'))
    const tokenScreenRef = useRef(null);
    const emergencySocketRef = useRef(null);
    const patientCallRef = useRef(null);
    const docCallPatientRef = useRef(null);
    const [timers, setTimers] = useState({});
    const [refreshCount, setRefreshCount] = useState(0);
    const intervalRefs = useRef({});
    const [requestApproval, setRequestApproval] = React.useState(false);
    const [rtApprovalCount, setRTapprovalCount] = React.useState(0);
    const [patientTagList, setpatientTagList] = React.useState([]);

    useEffect(() => {
        const init = async () => {
            // clearCachevalue("DoctorPatientData"); // don't clear the patient data if the user swipe back to the doctor notes from home this will cause the patient details to get lost and show blank screen and ends with 500
            clearCachevalue("CurrentDoctorPatientData");
            clearCachevalue("updatePatient");

            const storedClinicId = idclinic ? idclinic : clinicId;
            const selectedDate = JSON.parse(getCachevalue('SelectedDate'));
            const loginData = logininfo;

            const date = selectedDate ? new Date(selectedDate) : new Date();
            setdataselect(date);

            if (loginData?.is_qms_enabled) {
                WebSocketConnection(loginData);
            }

            if (clinicId) {
                setClinicID(storedClinicId);
                getPatientDetails();
                getDoctorsList(clinicId);
                getPatientTagList(clinicId);
            }
            setIsOPT(loginData.service_type === "OPT");
            setIsOptometry(loginData.service_type === "OPTOMETRY");
            setdatePicker(date);

            clearCachevalue('SelectedDate')
            setTimeout(() => {
                if (loginData?.module_name === "Doctor" && clinicId) {
                    updateAutolock(clinicId);
                }
            }, 1000);

            localSetItem('DoctorAppointmentDate', date);

            if (loginData.service_type !== "OPTOMETRY") {
                getDoctorCustomConfig();
            }

        };
        init();
    }, [clinicId]);

    useEffect(() => {
        if (getCachevalue('DoctorHomePageSize')) {
                setpageSize(+getCachevalue('DoctorHomePageSize'))
            } else {
                setpageSize(pageSize)
                setCachevalue(pageSize, 'DoctorHomePageSize')
            }
    }, [])

    useEffect(() => {
        if(CallPatientTrigger){
            getPatientDetails()
            ClearCalledTrigger()
        }
    }, [CallPatientTrigger])

    useEffect(() => {
        if (patientData && patientData?.length > 0) {
            const waitingPatientData = JSON.parse(getCachevalue('WaitingPatientData'))
            const waitingTime = JSON.parse(getCachevalue('waitingTime'))
            if (waitingPatientData?.waiting_timer === null) {
                const filterPatientData = patientData?.find(item => item?.patient_id === waitingPatientData?.patient_id)
                if (filterPatientData?.waiting_timer === null && filterPatientData?.appointment_status === 'With Doctor') {
                    postPatientStatus('', filterPatientData?.appointment_id, filterPatientData?.waiting_comment, waitingTime, null, true, filterPatientData)
                } else if (filterPatientData?.waiting_timer === null && filterPatientData?.appointment_status === 'Completed') {
                    postPatientStatus('Completed', filterPatientData?.appointment_id, filterPatientData?.waiting_comment, waitingTime, null, true, filterPatientData)
                } else if (filterPatientData?.waiting_timer === null && filterPatientData?.is_transfered) {
                    postPatientStatus('', filterPatientData?.appointment_id, filterPatientData?.waiting_comment, waitingTime, null, true, filterPatientData)
                }
            }
            const timer = setTimeout(() => {
                clearCachevalue('WaitingPatientData')
                clearCachevalue('waitingTime')
            }, 1000)
            return () => clearTimeout(timer);
        }
    }, [patientData])

    useEffect(() => {
        Object.entries(timers).forEach(([id, timer]) => {
            const shouldRun = timer.startTime && !timer.endTime && !timer.isPaused;

            if (shouldRun && !intervalRefs.current[id]) {
                intervalRefs.current[id] = setInterval(() => {
                    setTimers((prev) => {
                        const newTimers = { ...prev };
                        const t = newTimers[id];

                        if (!t || t.isPaused || t.endTime) return prev;

                        newTimers[id] = {
                            ...t,
                            currentTime: new Date(),
                        };

                        return newTimers;
                    });
                }, 250);
            }

            if ((!shouldRun || timer.endTime) && intervalRefs.current[id]) {
                clearInterval(intervalRefs.current[id]);
                intervalRefs.current[id] = null;
            }
        });

        return () => {
            Object.values(intervalRefs.current).forEach(clearInterval);
            intervalRefs.current = {};
        };
    }, [Object.keys(timers).join(','), refreshCount]);

    useEffect(() => {
        let isMounted = true;
        if (patientData && patientData.length > 0) {
            const updatedTimers = {};

            patientData.forEach((row) => {
                const id = row.appointment_id;
                const dilation = row.dilation_details ? row.dilation_details?.[0] : {};
                if (!dilation?.start_time) return;

                const startTime = new Date(dilation.start_time);
                const endTime = dilation.end_time ? new Date(dilation.end_time) : null;
                const isPaused = dilation.is_paused ?? false;
                const pauseTime = dilation.pause_time ? new Date(dilation.pause_time) : null;
                const pauseResumeLog = dilation.pause_resume_log || [];

                const totalPausedMs = calculateTotalPausedTime(
                    pauseResumeLog,
                    endTime,
                    isPaused,
                    pauseTime
                );

                const effectiveStartTime = new Date(startTime.getTime() + totalPausedMs);

                const currentTime = endTime
                    ? endTime
                    : isPaused && pauseTime
                        ? pauseTime
                        : new Date();

                updatedTimers[id] = {
                    startTime: effectiveStartTime,
                    originalStartTime: startTime,
                    endTime,
                    currentTime,
                    isPaused,
                    pauseStartTime: isPaused ? pauseTime : null,
                    totalPausedMs,
                };
            });
            if (isMounted && Object.keys(updatedTimers).length > 0) {
                setTimers((prev) => ({ ...prev, ...updatedTimers }));
            }
        }
        return () => {
            isMounted = false;
        };
    }, [patientData]);

    const calculateTotalPausedTime = (log = [], endTime = null, isPaused = false, pauseTime = null) => {
        let totalPausedMs = 0;

        for (let i = 0; i < log.length; i++) {
            const pauseEntry = log[i];
            const resumeEntry = log[i + 1];

            if (pauseEntry.pause && resumeEntry?.resume) {
                const pause = new Date(pauseEntry.pause).getTime();
                const resume = new Date(resumeEntry.resume).getTime();
                totalPausedMs += resume - pause;
                i++;
            } else if (pauseEntry.pause && !resumeEntry) {
                // Handle last pause without resume
                const pause = new Date(pauseEntry.pause).getTime();
                let virtualResume;

                if (endTime) {
                    virtualResume = new Date(endTime).getTime();
                } else if (isPaused && pauseTime) {
                    virtualResume = new Date(pauseTime).getTime();
                } else {
                    virtualResume = new Date().getTime();
                }

                totalPausedMs += virtualResume - pause;
            }
        }

        return totalPausedMs;
    };

    const formatTimeDiff = (originalStart, current, totalPaused = 0) => {
        const s = new Date(originalStart).getTime();
        const e = new Date(current).getTime();
        const diff = e - s - totalPaused;

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        return (
            <Typography fontSize={'0.8vw'} fontWeight={600} color={diff > 1200000 ? 'red' : 'black'}>
                {diff > 0 ? `${hours} Hr : ${minutes} Min : ${seconds} Sec` : '0 Hr : 0 Min : 0 Sec'}
            </Typography>
        );
    };

    const WebSocketConnection = (userData) => {
        let emergencyChannel = userData?.emergency_channel_name;
        let docCallChannel = userData?.doctor_call_channel_name;
        let tokenScreen = userData?.token_screen_channel_name;
        let org_id = JSON.parse(localGetItem("org_id"))

        if (!emergencySocketRef.current) {
            emergencySocketRef.current = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_EMERGENCY_WEBSOCKET}${emergencyChannel}/?org_id=${org_id}`);
        }
        if (!docCallPatientRef.current) {
            docCallPatientRef.current = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_PATIENTCALL_WEBSOCKET}${docCallChannel}/?org_id=${org_id}`);
        }
        if (!tokenScreenRef.current && tokenScreen) {
            tokenScreenRef.current = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.TOKENSCREEN_WEBSOCKET}${tokenScreen}/?org_id=${org_id}`);
        }

        const socketMapping = {
            EmergencySocket: emergencySocketRef.current,
            PaitentCall: patientCallRef.current,
            DocCallPatient: docCallPatientRef.current,
            TokenScreen: tokenScreenRef.current,
        };

        Object.entries(socketMapping)?.forEach(([name, socket]) => {
            if (socket) {
                socket.onopen = () => {
                    console.log(`${name} WebSocket connected`);
                };
                socket.onclose = () => {
                    console.log(`${name} WebSocket disconnected`);
                    socketMapping[name] = null; // optional: to clear mapping ref
                };
                socket.onerror = (error) => {
                    console.log(`${name} WebSocket Error`, error);
                    socket.close();
                };
                socket.onmessage = (e) => {
                    const data = JSON.parse(e.data);
                    console.log(`${name} WebSocket Message`, data);
                    if (name === "PaitentCall" && data) {
                        // You can trigger actions here
                    }
                };
            }
        });
    };

    const getDoctorCustomConfig = () => {
        try {
            RestAPIService.getAllTwo(Serviceurls.DOC_OPT_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let status = response.data.data.app_landing_sts === 'Optometry' ? 'With Optometry' : response.data.data.app_landing_sts
                        setappointmentType(response.data.data.app_landing_sts ? status : '')
                    }
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error?.message)
        }
    }

    const updateAutolock = (id) => {
        try {
            let DoctorClinicId = localGetItem('SelectedDoctorClinicId')
            RestAPIService.getAllTwo(Serviceurls.DOC_NOTES_AUTO_LOCK + `?clinic_id=${id}`)
                .then(response => {
                    if (response.data.status === "success") {
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message)
                    }
                });
        } catch (e) {
            errorMessage(e.message);
        }
    }

    const getDoctorsList = (id) => {
        try {
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?clinic_id=${UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : id}`).
                then((response) => {
                    if (response.data.status === "success") {
                        setDoctorsList(response.data.data.filter((item) => (item.specialization_active === true)))
                    }
                    else {
                        errorMessage(response.data.message)
                    }
                }).catch((e) => {
                    errorMessage(e.message)
                })
        }
        catch (e) {
            errorMessage(e.message)
        }
    }

    const getPatientTagList = (id) => {
        try {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))                
        RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG + `?clinic_id=${UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : id}`).
            then((response) => {
              if (response.data.status === "success") {
                setpatientTagList(response.data.data)
              }
              else {
                errorMessage(response.data.message)
              }
            }).catch((e) => {
              errorMessage(e.message)
            })
        }
        catch (e) {
          errorMessage(e.message)
        }
      }

    const closeFilter = () => {
        setFilterOpen(false);
    }

    const ClearFilterData = () => {
        setSelectedPatientTags([])
        setFilterOpen(false);
        getPatientDetails()
    }

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
            <Box component={"div"} className='eMed_filter_Top'>
                <Typography variant='h6' fontWeight={600}>{("Filter")}</Typography>
                <Button style={{paddingLeft : '0'}} onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn' emed_tid='opHome_filter_close_btn'>
                <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
            </Box>
            <Box className="eMed_Filter_Header">
                <Typography marginLeft={"1vw"}>{("Patient Filter")}</Typography>
            </Box>
            <Box className='eMed_rts_middle' display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
                <Box>
                {localGetItem('show_patient_tag_filter') === 'true' ? 
                <Box className='eMed_rts_dropdown'>
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size='small'
                        options={patientTagList}
                        getOptionLabel={(option) => (option?.patient_tag_name)}
                        value={SelectedPatientTags}
                        onChange={(event, newValue) => {
                            setSelectedPatientTags(newValue) }
                        }
                        renderOption={(props, option) => (
                            <li {...props} key={option?.patient_tag_name}>
                                {option?.patient_tag_name}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={('Select Patient Tag')}
                                emed_tid = {"doctorName_TestID"}
                                sx={{ width: "21vw"}}
                            />
                        )}
                    />
                </Box> : null}
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                <Button variant='outlined' size="small" emed_tid='opHome_filter_clear_btn'
                    onClick={() => { ClearFilterData() }}
                    id="eMed_Config_btn">{("Clear")}</Button>
                <Button variant='contained' size="small" emed_tid='opHome_filter_search_btn' disabled={disableBtn}
                    onClick={() => {
                    getPatientDetails();
                    setFilterOpen(false);
                    }}
                    id="eMed_Config_btn">{("Search")}</Button>
                </Stack>
            </Box>
            </Box>
        )
    }


    const getPatientAppointmentStatusCount = () => {
        try {
            let StateDate = new Date(datePicker)
            let date = datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
            let DoctorClinicId = localGetItem('SelectedDoctorClinicId')
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            let ApiUrl = ""
            const patientTagFilter = SelectedPatientTags.map(tag => tag.patient_tag_name);
            if (UserData?.service_type === "OPTOMETRY") {
                ApiUrl = Serviceurls.DOC_APPOINTMENT_STATUS + `?clinic_id=${UserData?.clinic_id}&doctor_id=${(DoctorClinicId === 'all' ? "" : DoctorClinicId)}&appointment_date=${date}&patient_tag_name=${patientTagFilter}`
            } else {
                ApiUrl = Serviceurls.DOC_APPOINTMENT_STATUS + `?clinic_id=${DoctorClinicId}&appointment_date=${date}&patient_tag_name=${patientTagFilter}`
            }
            RestAPIService.getAll(ApiUrl)
                .then((response => {
                    if (response?.data?.status === 'success') {
                        settotalAppointment(response.data.data ? response.data.data : {})
                        setloading(false)
                    }
                })).catch(e => {
                    setloading(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPatientDetails = () => {
        try {
            setloading(true)
            const myUser = JSON.parse(localGetItem("loggedInUserInfo"))
            const UserData = myUser
            let StateDate = new Date(datePicker)
            let date = datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
            const localClinicId = localGetItem('SelectedDoctorClinicId');
            let clinicId = localGetItem('SelectedDoctorClinicId') !== null ? (localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : getCachevalue('SelectedDoctorClinic')) : ClinicID;
            let appType = appointmentType === 'All' ? '' : appointmentType === "Transferred" ? "Transfered" : appointmentType === "With Optometry" ? "Optometry" : appointmentType
            setCachevalue(date, 'OpAppDate')
            setCachevalue(appType, 'OPStatus')
            let ApiUrl = ""
            const patientTagFilter = SelectedPatientTags.map(tag => tag.patient_tag_name);
            if (UserData?.service_type === "OPTOMETRY") {
                ApiUrl = Serviceurls.DOC_OPTHOMETRY_APPOINTMENT_LIST + "?appointment_date=" + date + "&appointment_status=" + appType + (getCachevalue('DoctorUserChanged') === 'true' ? "" : '&doctor_id=' + (clinicId === 'all' ? "" : +clinicId)) + '&patient_tag_name=' + patientTagFilter
            } else {
                ApiUrl = Serviceurls.DOC_APPOINTMENT_LIST + "?appointment_date=" + date + "&appointment_status=" + appType + '&clinic_id=' + clinicId + '&patient_tag_name=' + patientTagFilter
            }
            RestAPIService.getAll(ApiUrl)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setloading(false)
                        setPatientData(response.data.data)
                        setisDocOnEmergency(response.data?.out_for_emergency ? response.data?.out_for_emergency : false)
                        setisOPTOoutOfOffice(response.data?.is_out_of_office ?? true)
                        setpatientCount(response.data?.patient_arrived_count ? response.data?.patient_arrived_count : {})
                        getPatientAppointmentStatusCount()
                        setRTapprovalCount(response.data?.doctor_approval_list_count ? response.data?.doctor_approval_list_count : 0)
                    }
                })
                .catch((error) => {
                    setloading(false)
                    if (error.response.data.status === 'error') {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (e) {
            setloading(false)
            errorMessage(e.message)
        }
    }

    const cardDetails = useCallback((label, value, color) => {
        const displayLbl = label?.length > 12 ? label?.slice(0, 12) + '...' : label;
        const showArrow = label === "Arrived" || label === "With Doctor";
        return (
            <Card className="eMed_App_Card" elevation={3}
                sx={{
                    width: '4.5vw', height: '3.6vw', display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                    alignItems: 'center', textTransform: 'capitalize', cursor: 'pointer'
                }}
                onClick={() => { setappointmentType(label); }}
            >
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                    <Typography sx={{ fontSize: '0.7vw', textAlign: "center", fontWeight: "bold" }}>{value}</Typography>
                        {showArrow && (
                            <Box sx={{ display: 'flex', alignItems: 'flex-end', marginLeft: '1vw' }}>
                                <img src={ImagePaths.ArrowDrop.default}
                                    fontSize="small"
                                    style={{ color: "#555", width: '.8vw', height: '.8vw' }}
                                />
                            </Box>
                        )}
                    </Box>
                    <Tooltip title={label.length > 12 ? label : ''} placement="top" arrow>
                        <Typography sx={{ fontSize: '.6vw', textAlign: "center" }}>{displayLbl}</Typography>
                    </Tooltip>
                </Box>
                <Box sx={{
                    backgroundColor: color,
                    height: appointmentType === label ? '15%' : '5%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}
                />
            </Card>
        );
    }, [appointmentType, setappointmentType])


    const headerCards = () => {
        let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
            JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
                appointment_Status_opt : appointment_Status_opt
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let is_opt = false
        let is_selectopt = false
        var is_optdoc = DoctorsList.find((item) => {
            if ((item.specialization_name === Serviceurls.ROLE_OPT || item.specialization_name === Serviceurls.ROLE_OPTOMETRY) && isOPT) {
                is_opt = true
            } else {
                is_opt = false
            }
            return is_opt
        }
        )
        // select Opt Doc filter
        var is_optselect = getCachevalue('SelectedDoctorID')
        var is_optDocselect = DoctorsList.filter((item) => (item.doctor_id === +is_optselect))
        var is_selectoptdoc = is_optDocselect.find((item) => {
            if ((item.specialization_name === Serviceurls.ROLE_OPT || item.specialization_name === Serviceurls.ROLE_OPTOMETRY) && isOPT) {
                is_selectopt = true
            } else {
                is_selectopt = false
                is_optdoc = false
            }
            return is_selectopt, is_optdoc
        }
        )
        return (
            <Box component={'div'} sx={{ display: 'flex', alignItems: 'center', width: '100%', height: "100%", justifyContent: "space-between" }}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '8%', height: "100%" }}>
                    {isOptometry ? null : <Tooltip title={'Create Patient'} placement='top' arrow>
                        <IconButton onClick={() => { history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true } }) }}>
                            <img style={{ width: '2.5vw', height: '2.5vw' }} src={ImagePaths.CreatePatient.default} alt={"Add Patient"} />
                        </IconButton>
                    </Tooltip>}
                    {(localGetItem('isNewBilling') === 'true' && !isOptometry && UserData?.enable_radiotherapy) ? <Tooltip title={'RT Approvals'} placement='top' arrow>
                        <IconButton onClick={() => { history.push({ pathname: "/DoctorHome/RadiotherapyNewDocApproval", state: { fromCreate: true } }) }}>
                            <Badge badgeContent={rtApprovalCount || 0} color="error" max={999}>
                                <img style={{ width: '2.5vw', height: '2.5vw' }} src={ImagePaths.ApprovalRoundIcon.default} alt={"RT Approvals"} />
                            </Badge>
                        </IconButton>
                    </Tooltip> : null}
                    {/* <Box sx={{ display: 'flex', justifyItems: 'center', flexDirection: 'column', }}>
                        <Typography sx={{ fontSize: '0.8vw' }}><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.NewPatient.default} alt={'New Patient'} /> {`New (${patientCount?.new_patient || 0})`}</Typography>
                        <Typography sx={{ fontSize: '0.8vw' }}><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.EstablishedPatient.default} alt={'Review Patient'} /> {`Established (${patientCount?.old_patient || 0})`}</Typography>
                        <Typography sx={{ fontSize: '0.8vw' }}><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.ReviewPatient.default} alt={'Old Patient'} /> {`Review (${patientCount?.review_patient || 0})`}</Typography>
                    </Box> */}
                </Box>
                <Box sx={{ width: '92%', height: '100%', display: 'flex', justifyContent: "flex-end", alignItems: 'center', gap: "0.625dvw" }}>
                    {cardDetails('All', totalAppointment?.today_patients || 0, '#616161')}
                    {cardDetails('Booked', totalAppointment?.booked || 0, '#616161')}
                    {cardDetails('Ip Appointment', totalAppointment?.ip_appointment || 0, '#5fbe39')}
                    {cardDetails('Arrived', totalAppointment?.checked_in_patients || 0, '#0461B7')}
                    <Collapse in={["Arrived", "With Nurse", "With OPTOS", "With Optometry", "Optometry Completed"].includes(appointmentType)} orientation="horizontal" timeout={500}>
                        <Box sx={{ display: "flex", gap: "0.5rem" }}>
                            {(totalAppointment.with_nurse > 0 || appointmentStatus[1]?.is_checked) && cardDetails('With Nurse', totalAppointment?.with_nurse || 0, '#AF2591')}
                            {((totalAppointment.with_optos > 0 || appointmentStatus[2]?.is_checked) && (isOptometry || ((is_optdoc || is_selectoptdoc) || isOPT))) && cardDetails('With OPTOS', totalAppointment?.with_optos || 0, '#fa0004')}
                            {((totalAppointment?.with_optometry > 0 || appointmentStatus[3]?.is_checked) && (isOptometry || ((is_optdoc || is_selectoptdoc) || isOPT))) && cardDetails('With Optometry', totalAppointment?.with_optometry || 0, '#ffff33')}
                            {((totalAppointment?.optometry_completed > 0 || appointmentStatus[4]?.is_checked) && (isOptometry || ((is_optdoc || is_selectoptdoc) || isOPT))) && cardDetails('Optometry Completed', totalAppointment?.optometry_completed || 0, 'orange')}
                        </Box>
                    </Collapse>
                    {cardDetails('With Doctor', totalAppointment?.with_doctor || 0, '#29B6F6')}
                    <Collapse in={["With Doctor", "In Opticals", "Opticals Completed", "With Counsellor", "Scan/Surgery"].includes(appointmentType)} orientation="horizontal" timeout={500}>
                        <Box sx={{ display: "flex", gap: "0.5rem" }}>
                            {(totalAppointment?.in_opticals > 0 || appointmentStatus[6]?.is_checked) && (isOptometry || ((is_optdoc || is_selectoptdoc) || isOPT)) && cardDetails('In Opticals', totalAppointment?.in_opticals || 0, '#00d773ff')}
                            {(totalAppointment?.opticals_completed > 0 || appointmentStatus[7]?.is_checked) && (isOptometry || ((is_optdoc || is_selectoptdoc) || isOPT)) && cardDetails('Opticals Completed', totalAppointment?.opticals_completed || 0, '#2ee9e9ff')}
                            {(totalAppointment.with_counsellor > 0 || appointmentStatus[8]?.is_checked) && cardDetails('With Counsellor', totalAppointment?.with_counsellor || 0, '#027f7d')}
                            {((totalAppointment?.scan > 0 || appointmentStatus[9]?.is_checked) && (isOptometry || ((is_optdoc || is_selectoptdoc) || isOPT))) && cardDetails('Scan/Surgery', totalAppointment?.scan || 0, '#ff9900')}
                        </Box>
                    </Collapse>
                    {cardDetails('Completed', totalAppointment?.checked_out_patients || 0, '#1E972A')}
                    {cardDetails('Cancelled', totalAppointment?.cancelled_patients || 0, '#B8170D')}
                    {cardDetails('Transferred', totalAppointment?.transfered || 0, '#6baf08')}

                    {getCachevalue("DoctorUserChanged") === 'true' ? null : 
                    isOptometry && localGetItem("isNewBilling") === "true" ? <Button sx={{ width: '5dvw', textTransform: 'capitalize', fontSize: '.8vw', height: '3.6vw' }} size='small' variant='contained' color='info'
                        disabled={disableBtn}
                        onClick={() => {
                            const newStatus = !isOPTOoutOfOffice; // new value to be passed
                            setisOPTOoutOfOffice(newStatus);
                            setdisableBtn(true);
                            setTimeout(() => {
                                onOutofMappping(newStatus); // pass the correct updated value
                            }, 1000);
                        }}>
                        {isOPTOoutOfOffice ? `Check In` : `Out of Office`}
                    </Button> : null}
                    {getCachevalue("DoctorUserChanged") === 'true' ? null : 
                    isOptometry ? null : <Button sx={{ width: '5dvw', textTransform: 'capitalize', fontSize: '.8vw', height: '3.6vw' }} size='small' variant='contained' color='error'
                        disabled={disableBtn}
                        onClick={() => {
                            const newStatus = !isDocOnEmergency; // new value to be passed
                            setisDocOnEmergency(newStatus);
                            setdisableBtn(true);
                            setTimeout(() => {
                                onEmergency(newStatus); // pass the correct updated value
                            }, 1000);
                        }}>
                        {isDocOnEmergency ? 'Stop Emergency' : 'Emergency'}
                    </Button>}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            open={DatePickerOpen}
                            onOpen={() => { setDatePickerOpen(true) }}
                            onClose={() => { setDatePickerOpen(false) }}
                            value={datePicker}
                            name={"datePicker"}
                            inputFormat='DD-MM-YYYY'
                            views={["year", "month", "day"]}
                            onChange={(newDate) => {
                                setdatePicker(newDate)
                                setTimeout(() => {
                                    setCachevalue(JSON.stringify(newDate), 'SelectedDate')
                                    localSetItem('DoctorAppointmentDate', newDate)
                                }, 1000)
                            }}
                            renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10dvw' }} size='small' {...params} onClick={() => { setDatePickerOpen(true) }} />}
                        />
                    </LocalizationProvider>
                    {localGetItem('show_patient_tag_filter') === 'true' ? 
                        <Tooltip title="Filter" placement='top' arrow>
                            <Button className='eMed_usrconf_btn' emed_tid='opHome_filter_btn' onClick={() => { setFilterOpen(true) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Tooltip> : null
                    }
                </Box>
            </Box>
        )
    }

    const onEmergency = (newEmergencyStatus) => {
        try {
            let clinicId = JSON.parse(localGetItem("SelectedDoctorClinicId"))
            let data = {
                'out_for_emergency': newEmergencyStatus,
                'clinic_id': ClinicID ? +ClinicID : clinicId || null
            }
            RestAPIService.create(data, Serviceurls.DOC_WENT_FOR_EMERGENCY)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response.data.message)
                        if (emergencySocketRef.current) {
                            emergencySocketRef.current.send(JSON.stringify({
                                id: response?.data?.data?.id || null
                            }));
                        }
                        setdisableBtn(false)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                    setdisableBtn(false)
                })
        } catch (error) {
            setdisableBtn(false)
            errorMessage(error.message)
        }
    }

    const onOutofMappping = (newEmergencyStatus) => {
        try {
            let data = {
                is_out_of_office: !isOPTOoutOfOffice,
            }
            RestAPIService.create(data, Serviceurls.DOC_OPTOMETRY_OOO_STUATUS)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response.data.message)
                        setdisableBtn(false)
                        getPatientDetails()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                    setdisableBtn(false)
                })
        } catch (error) {
            setdisableBtn(false)
            errorMessage(error.message)
        }
    }

    useEffect(() => {
        if (ClinicID && appointmentType) {
            getPatientDetails()
            // getDoctorsList(ClinicID);
        }
    }, [datePicker, appointmentType])

    const addComments = (value) => {
        if (waitCmtText) {
            var data1 = value?.waiting_comment
            var data2 = []
            var date = new Date()
            var options = { timeZone: 'Asia/Kolkata', hour12: true, hour: 'numeric', minute: 'numeric' }
            var timeString = date.toLocaleTimeString('en-IN', options)
            data2.push({
                "date": DateTime.fromJSDate(date).toFormat('dd-MM-yyyy'),
                "time": timeString,
                "comments": waitCmtText.replace(/\s+/g, ' ').trim(),
                "user_name": logininfo?.display_name,
                "appointment_status": value?.appointment_status,
            })
            var cmtData = [...data1, ...data2]
            setwaitingCmts(false)
            postPatientStatus('', SelectedPatientDetails.appointment_id, cmtData)
        } else {
            errorMessage('Please Enter The Comment')
        }

    }
    const renderWaitingCmt = (data) => {
        return (
            (SelectedPatientDetails.patient_id == data.patient_id && SelectedPatientDetails?.appointment_id === data?.appointment_id) ?
                <Dialog
                    open={waitingCmts}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
                        <div>
                            {"Waiting Comments"}
                        </div>
                        <div className="eMed_DialogBox_Close">
                            <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { setwaitingCmts(false); setwaitCmtText(''); }} />
                        </div>
                    </div>
                    {
                        data.appointment_status !== "Completed" ?
                            <div>
                                <DialogContent>
                                    <TextField
                                        sx={{ width: '25vw' }}
                                        multiline
                                        inputProps={{ maxLength: cmt_Char_limit }}
                                        rows={3}
                                        placeholder={"Add Comments"}
                                        variant="outlined"
                                        value={waitCmtText}
                                        onChange={(e) => {
                                            setwaitCmtText(e.target.value)
                                        }} />
                                </DialogContent>
                                <DialogActions id="eMed_DialogBox_Btn">
                                    <Button size="small" variant='outlined' id="eMed_Dia_Btn" onClick={() => { setwaitCmtText('') }}>
                                        {'Clear'}
                                    </Button>
                                    <Button size="small" variant='contained' id="eMed_Dia_Btn" onClick={() => { addComments(data) }}>
                                        {'Add'}
                                    </Button>
                                </DialogActions>
                            </div> : null
                    }
                    {data?.waiting_comment?.length > 0 ?
                        <DialogContent id='eMed_OP_oldComments_Con'>
                            <div className='eMed_OP_oldComments_Con1'>
                                {data?.waiting_comment?.map((item) => (
                                    <div style={{ height: 'auto' }} >
                                        <p className='eMed_OP_Cmts_Text'>{item?.comments}</p>
                                        <p className='eMed_OP_Cmts_Text1'>{item?.time + ' | ' + item?.date}</p>
                                        <hr />
                                    </div>
                                ))}
                            </div>
                        </DialogContent> :
                        <DialogContent id='eMed_OP_no_comments_div'>
                            <Typography className='eMed_OP_no_comments_txt'>No Comments</Typography>
                        </DialogContent>}
                </Dialog> : null
        )
    }
    const AppointmentTypeIcon = (type) => {
        switch (type) {
            case "Telephonic Appointment": return <Box><Tooltip placement='top' title={"Telephonic Appointment"} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.Telephonic.default}></img></Tooltip></Box>
            case "Mobile Appointment": return <Box><Tooltip placement='top' title={"Mobile Appointment"} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.Phone.default}></img></Tooltip></Box>
            case "Online Appointment": return <Box><Tooltip placement='top' title={"Online Appointment"} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.Web.default}></img></Tooltip></Box>
            case "Web Appointment": return <Box><Tooltip placement='top' title={"Web Appointment"} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.Web.default}></img></Tooltip></Box>
            case "Walk in Appointment": return <Box><Tooltip placement='top' title={"Walk-in Appointment"} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.Walkin.default}></img></Tooltip></Box>
            case "transfer": return <Box><Tooltip placement='top' title={"Transferred"} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.Transfer.default}></img></Tooltip></Box>
            default: return <Box><Tooltip placement='top' title={type === null ? "Others" : type} arrow><img style={{ width: '1.3vw', height: '1.3vw' }} src={ImagePaths.DefaultAppointType.default}></img></Tooltip></Box>
        }
    }

    const renderMenu = (data) => {
        let multi_option = [
            { label: "Next Appointment", value: "NextAppointment" },
            { label: "Print Doctor Notes", value: "PrintDoctorNotes" },
            { label: "Print Prescription", value: "PrintPrescription" },
            { label: "OP Barcode Print", value: "OpBarcode" },
            { label: "Prescription Template", value: "PrescriptionTemplate" },
            { label: "BarCode", value: "CommonBarcode" },
            { label: "Medical Record Print", value: "MedicalRecord" },
            { label: "Patient Remarks", value: "PatientRemarks" },
        ]
        if (data?.row?.is_emergency) {
            multi_option?.push({ label: 'Disable Highlight', value: 'ChangeTag' })
        }
        return (
            <Box>
                <Box>
                    <Tooltip title={"More"} placement='top' arrow>
                        <IconButton
                            onClick={(e) => {
                                setanchorEl(e.currentTarget)
                                setselectedRow(data.id)
                                setisSelected(true)
                                setremarkText(data?.comments)
                            }}
                            disabled={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show" || data.row.transfer_appointment) ? true : false}
                        >
                            <MoreVertIcon />
                        </IconButton>
                    </Tooltip>
                    {(isSelected && selectedRow == data.id) ?
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => {
                                setanchorEl(null)
                            }}
                        >
                            {multi_option.map((option, i) => (
                                <MenuItem key={i}
                                    disabled={(slctMenuOption === option.value) ||
                                        (((data.row.appointment_status !== "Completed" && data.row.appointment_status !== "With Doctor") ||
                                            data.row.is_nurse) && (option.label === "PrintDoctorNotes" || option.label === "PrintPrescription")) ||
                                        (data.row.is_nurse && option.label === "PresTem") ||
                                        (option.label === "TransAppoint" && data.row.appointment_status === "Completed")
                                        ? true : false}
                                    onClick={() => {
                                        setselectedOption(option.value)
                                        setanchorEl(null)
                                        setSelectedPatientDetails(data.row)
                                        settokenNum(data.row.token_number)
                                        setslctMenuOption(option.value)
                                    }}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Menu> : null}
                </Box>
            </Box>
        )
    }

    const DocPatientCall = (appDetail) => {
        try {
            let data = {
                appointment_id: appDetail?.appointment_id ? appDetail?.appointment_id : null
            }
            RestAPIService.create(data, Serviceurls.DOC_CALL_PATIENT)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let id = response?.data?.data?.id ? response?.data?.data?.id : null
                        successMessage(response.data.message)
                        if (docCallPatientRef.current) {
                            docCallPatientRef.current.send(JSON.stringify({ id: id }))
                        }
                        if (tokenScreenRef.current) {
                            tokenScreenRef.current.send(JSON.stringify({ id: id }))
                        }
                        setTimeout(() => {
                            getPatientDetails()
                            setdisableBtn(false)
                        }, 1000);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                        if (error.response.data.message?.includes("Patient already assigned")) {
                            getPatientDetails()
                        }
                    } else {
                        errorMessage(error.message)
                    }
                    setdisableBtn(false)
                })
        } catch (error) {
            setdisableBtn(false)
            errorMessage(error.message)
        }
    }

    const StatusBtns = (data, id) => {
        return (
            <Box>
                {data.appointment_status === "Completed" ?
                    <Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>Completed</Button> :
                    data.appointment_status === "Cancelled" ?
                        <Tooltip title={`Cancelled Due to ${data?.cancel_reason}`} arrow placement='top'>
                            <Button sx={{ textTransform: 'capitalize', width: "10vw", }} color='error' size='small' disableElevation variant='contained'>Cancelled</Button>
                        </Tooltip> :
                        data?.transfer_appointment && data?.appointment_status !== 'Cancelled' ?
                            <Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>Transferred</Button> :
                            <Box sx={{ overflowX: "auto", whiteSpace: "nowrap", height: 'auto', width: '20vw' }}>{groupBtn(data, id)}</Box>}
            </Box>
        )
    }
    const groupBtn = (data, id) => {
        let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
            JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
                appointment_Status_opt : appointment_Status_opt

        const timer = timers[id];

        const handleComplete = () => {
            let stopTime;
            let shouldInsertDummyResume = false;

            if (timer?.isPaused && timer?.pauseStartTime) {
                stopTime = timer.pauseStartTime;
                shouldInsertDummyResume = true;
            } else {
                stopTime = new Date();
            }

            UpdateDilationTime(id, false, true, false, false, false, shouldInsertDummyResume).then(() => {
                setTimers((prev) => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        endTime: stopTime,
                        currentTime: stopTime,
                    },
                }));
            });
            setTimeout(() => {
                postPatientStatus('Completed', id, data.waiting_comment)
            }, 500);
        };
        return (
            <ButtonGroup size="small" sx={{ backgroundColor: '#E4F2F0' }}>
                <Tooltip title={'Arrived'} placement='top' arrow>
                    <Button id='eMed_docStatus_Btn' key="Arrived" onClick={() => {
                        var today = new Date()
                        var date = DateTime.fromJSDate(today).toFormat('yyyy-MM-dd')
                        var AptDate = new Date(data.appointment_date)
                        var AppointmentDate = DateTime.fromJSDate(AptDate).toFormat('yyyy-MM-dd')

                        if (date === AppointmentDate) {
                            postPatientStatus('Arrived', id, data.waiting_comment)
                        } else {
                            errorMessage("Arrived status can't be changed for future or past dates.")
                        }

                    }
                    } disabled={(data.appointment_status === "Booked" || data.appointment_status === "Ip Appointment" || data.appointment_status === "On Queue") ? false : true}>
                        <img className='eMed_statusIcon' src={(appointmentSet.has(data.appointment_status)) ? ImagePaths.StatusArrivedFill.default : ImagePaths.StatusArrived.default} alt='Arrived' />
                    </Button>
                </Tooltip>
                {totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                    <Tooltip title={'With Nurse'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="WithNurse" onClick={() => {
                            postPatientStatus('With Nurse', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                        }
                        } disabled={(data.appointment_status === "Arrived" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true}>
                            <img className='eMed_statusIcon' src={(sliceSet(1)?.has(data.appointment_status)) ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default} alt='With Nurse' />
                        </Button>
                    </Tooltip> :
                    appointmentStatus[1]?.is_checked ?
                        <Tooltip title={'With Nurse'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="WithNurse" onClick={() => {
                                postPatientStatus('With Nurse', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                            }
                            } disabled={(data.appointment_status === "Arrived" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true}>
                                <img className='eMed_statusIcon' src={(sliceSet(1)?.has(data.appointment_status)) ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default} alt='With Nurse' />
                            </Button>
                        </Tooltip> : null}
                {totalAppointment?.with_optos > 0 && !appointmentStatus[2]?.is_checked ?
                    <Tooltip title={'With OPTOS'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="WithOPTOS" onClick={() => {
                            postPatientStatus('With OPTOS', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                        }
                        } disabled={(data.appointment_status === "With Nurse" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true}>
                            <img className='eMed_statusIcon' src={(sliceSet(2)?.has(data.appointment_status)) ? ImagePaths.OPTOSfill.default : ImagePaths.OPTOS.default} alt='With OPTOS' />
                        </Button>
                    </Tooltip> :
                    appointmentStatus[2]?.is_checked ?
                        <Tooltip title={'With OPTOS'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="With OPTOS" onClick={() => {
                                postPatientStatus('With OPTOS', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                            }
                            } disabled={(data.appointment_status === "With Nurse" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true}>
                                <img className='eMed_statusIcon' src={(sliceSet(2)?.has(data.appointment_status)) ? ImagePaths.OPTOSfill.default : ImagePaths.OPTOS.default} alt='With OPTOS' />
                            </Button>
                        </Tooltip> : null}
                {/* For Optometry Icon start */}
                {(totalAppointment?.with_optometry > 0 && !appointmentStatus[3]?.is_checked && (isOPT || isOptometry)) ?
                    <Tooltip title={'Optometry'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="Optometry" onClick={() => {
                            postPatientStatus('Optometry', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                        }
                        }
                            disabled={appointmentStatus[1]?.is_checked ?
                                (((data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor") ? false : true)) :
                                ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor") ? false : true)
                            }
                        >
                            <img className='eMed_statusIcon' src={(sliceSet(3)?.has(data.appointment_status)) ? ImagePaths.OptometryFill.default : ImagePaths.Optometry.default} alt='With Nurse' />
                        </Button>
                    </Tooltip> :
                    (appointmentStatus[3]?.is_checked && (isOPT || isOptometry)) ?
                        <Tooltip title={'Optometry'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="Optometry" onClick={() => {
                                postPatientStatus('Optometry', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                            }
                            }
                                disabled={appointmentStatus[1]?.is_checked ?
                                    (((data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor") ? false : true)) :
                                    ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor") ? false : true)
                                }
                            >
                                <img className='eMed_statusIcon' src={(sliceSet(3)?.has(data.appointment_status)) ? ImagePaths.OptometryFill.default : ImagePaths.Optometry.default} alt='With Nurse' />
                            </Button>
                        </Tooltip> : null}
                {/* For Optometry Icon end */}
                {/* For Optometry completed start */}
                {((totalAppointment?.optometry_completed > 0 && !appointmentStatus[4]?.is_checked) || (appointmentStatus[4]?.is_checked)) && (isOPT || isOptometry) ?
                    <Tooltip title={'Optometry Completed'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="Optometry Completed" onClick={() => {
                            postPatientStatus('Optometry Completed', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                        }}
                            disabled={(((data.appointment_status === "Optometry") ? false : true))}
                        >
                            <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(4)?.has(data.appointment_status)) ? ImagePaths.withOptCompletedOn.default : ImagePaths.withOptCompletedOff.default} alt='Opt Complete' />
                        </Button>
                    </Tooltip> : null}
                {/* For Optometry completed end */}
                <Tooltip title={'With Doctor'} placement='top' arrow>
                    <Button id='eMed_docStatus_Btn' key="WithDoctor" onClick={() => {
                        postPatientStatus('With Doctor', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, false, data)
                    }
                    }
                        disabled={totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                            ((data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true)) :
                            appointmentStatus[1]?.is_checked ?
                                ((data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true)) :
                                ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true))
                        }
                    >
                        <img className='eMed_statusIcon' src={sliceSet(5)?.has(data.appointment_status) ? ImagePaths.StatusDoctorFill.default : ImagePaths.StatusDoctor.default} alt='With Doctor' />
                    </Button>
                </Tooltip>
                {/* in optical start */}
                {totalAppointment?.in_opticals > 0 && !appointmentStatus[6]?.is_checked && (isOPT || isOptometry) ?
                    <Tooltip title={'In Opticals'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="InOpticals" onClick={() => {
                            postPatientStatus('In Opticals', id, data.waiting_comment)
                        }}
                            disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true))}
                        >
                            <img className='eMed_statusIcon' src={sliceSet(6)?.has(data.appointment_status) ? ImagePaths.InOpticals.default : ImagePaths.InOpticalsOff.default} alt='In Opticals' />
                        </Button>
                    </Tooltip> :
                    appointmentStatus[6]?.is_checked && (isOPT || isOptometry) ?
                        <Tooltip title={'In Opticals'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="InOpticals" onClick={() => {
                                postPatientStatus('In Opticals', id, data.waiting_comment)
                            }
                            }
                                disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true))}
                            >
                                <img className='eMed_statusIcon' src={sliceSet(6)?.has(data.appointment_status) ? ImagePaths.InOpticals.default : ImagePaths.InOpticalsOff.default} alt='In Opticals' />
                            </Button>
                        </Tooltip> : null}
                {/* in optical end */}
                {/* in optical completed start */}
                {totalAppointment?.opticals_completed > 0 && !appointmentStatus[7]?.is_checked && (isOPT || isOptometry) ?
                    <Tooltip title={'Opticals Completed'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="OpticalsCompleted" onClick={() => {
                            postPatientStatus('Opticals Completed', id, data.waiting_comment)
                        }}
                            disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true))}
                        >
                            <img className='eMed_statusIcon' src={sliceSet(7)?.has(data.appointment_status) ? ImagePaths.OpticalsCompleted.default : ImagePaths.OpticalsCompletedOff.default} alt='Opticals Completed' />
                        </Button>
                    </Tooltip> :
                    appointmentStatus[7]?.is_checked && (isOPT || isOptometry) ?
                        <Tooltip title={'Opticals Completed'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="OpticalsCompleted" onClick={() => {
                                postPatientStatus('Opticals Completed', id, data.waiting_comment)
                            }
                            }
                                disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true))}
                            >
                                <img className='eMed_statusIcon' src={sliceSet(7)?.has(data.appointment_status) ? ImagePaths.OpticalsCompleted.default : ImagePaths.OpticalsCompletedOff.default} alt='Opticals Completed' />
                            </Button>
                        </Tooltip> : null}
                {/* in optical completed end */}
                {totalAppointment?.with_counsellor > 0 && !appointmentStatus[8]?.is_checked ?
                    <Tooltip title={'With Counsellor'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="WithCounsellor" onClick={() => {
                            postPatientStatus('With Counsellor', id, data.waiting_comment)
                        }}
                            disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' ? false : true))}
                        >
                            <img className='eMed_statusIcon' src={sliceSet(8)?.has(data.appointment_status) ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default} alt='With Counsellor' />
                        </Button>
                    </Tooltip> :
                    appointmentStatus[8]?.is_checked ?
                        <Tooltip title={'With Counsellor'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="WithCounsellor" onClick={() => {
                                postPatientStatus('With Counsellor', id, data.waiting_comment)
                            }
                            }
                                disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' ? false : true))}
                            >
                                <img className='eMed_statusIcon' src={sliceSet(8)?.has(data.appointment_status) ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default} alt='With Counsellor' />
                            </Button>
                        </Tooltip> : null}
                {/* For Optometry Icon start */}
                {totalAppointment?.scan > 0 && !appointmentStatus[9]?.is_checked && (isOPT || isOptometry) ?
                    <Tooltip title={'Scan/Surgery'} placement='top' arrow>
                        <Button id='eMed_docStatus_Btn' key="Scan/Surgery" onClick={() => {
                            postPatientStatus('Scan/Surgery', id, data.waiting_comment)
                        }
                        } disabled={(data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'With Counsellor') ? false : true}>
                            <img className='eMed_statusIcon' src={(data.appointment_status === "Scan/Surgery") ? ImagePaths.ScanSurgeryFill.default : ImagePaths.ScanSurgery.default} alt='With Nurse' />
                        </Button>
                    </Tooltip> :
                    (appointmentStatus[9]?.is_checked && (isOPT || isOptometry)) ?
                        <Tooltip title={'Scan/Surgery'} placement='top' arrow>
                            <Button id='eMed_docStatus_Btn' key="Scan/Surgery" onClick={() => {
                                postPatientStatus('Scan/Surgery', id, data.waiting_comment)
                            }
                            } disabled={(data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'With Counsellor') ? false : true}>
                                <img className='eMed_statusIcon' src={(data.appointment_status === "Scan/Surgery") ? ImagePaths.ScanSurgeryFill.default : ImagePaths.ScanSurgery.default} alt='With Nurse' />
                            </Button>
                        </Tooltip> : null}
                {/* For Optometry Icon end */}
                <Tooltip title={'Completed'} placement='top' arrow>
                    <Button id='eMed_docStatus_Btn' key="Completed" onClick={() => {
                        if (data?.dilation_details?.[0]?.status !== 'completed' && data?.dilation_details) {
                            handleComplete();
                        } else {
                            postPatientStatus('Completed', id, data.waiting_comment)
                        }
                    }
                    } disabled={data.appointment_status === 'With Doctor' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'With Counsellor' ? false : true} >
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={ImagePaths.StatusCompleted.default} alt='Completed' />
                    </Button>
                </Tooltip>
            </ButtonGroup>
        )
    }

    const UpdateDilationTime = (id, StartTime = false, EndTime = false, isPaused = false, reset = false, resume = false) => {
        return new Promise((resolve) => {
            try {
                setloading(true);

                const data = {
                    dilation: 'Homide',
                    appointment_id: id,
                    set_start_time: StartTime,
                    set_end_time: EndTime,
                    pause: isPaused,
                    reset: reset,
                    resume: resume,
                };

                RestAPIService.create(data, Serviceurls.DOC_DILATION_TIMER_UPDATE)
                    .then((response) => {
                        setloading(false);
                        if (response.data.status === "success") {
                            getPatientDetails();
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch((e) => {
                        setloading(false);
                        errorMessage(e?.response?.data?.message || e.message);
                        resolve(false);
                    });
            } catch (e) {
                setloading(false);
                errorMessage(e.message);
                resolve(false);
            }
        });
    };

    const homeTbl = () => {
        let isTodayDate = DateTime.fromJSDate(new Date(datePicker)).toFormat('yyyy-MM-dd') === DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
        patientData.forEach((element, index) => { element.sno = index + 1 })
        const columns = [
            {
                field: 'patient_account_number', headerName: 'UHID', flex: 0.08,
                renderCell: (params) => {
                    return (
                        <Box>{params?.row?.patient_account_number.length > 15 ?
                            <Tooltip title={params?.row?.patient_account_number} placement='top' arrow>
                                <Typography sx={{ fontSize: '0.9vw' }}>{'...' + params?.row?.patient_account_number.slice(-15)}</Typography>
                            </Tooltip> :
                            <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.patient_account_number}</Typography>
                        }
                        </Box>
                    )
                }
            },
            {
                field: 'patient_name', headerName: 'Patient Name', flex: 0.12,
                renderCell: (params) => {
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box>
                                {params?.row?.patient_name.length > 15 ?
                                    <Tooltip title={params?.row?.patient_name} placement='top' arrow>
                                        <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.patient_name.slice(0, 15) + '...'}</Typography>
                                    </Tooltip> :
                                    <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.patient_name}</Typography>
                                }
                            </Box>
                            <Box>
                                <Tooltip title={'Add Comments'} placement='top' arrow>
                                    <IconButton disabled={params.row.appointment_status === "Cancelled" || getCachevalue('DoctorUserChanged')=== 'true'} onMouseOver={() => { setonAddComment(true) }} onMouseLeave={() => { setonAddComment(false) }} onClick={() => { setwaitingCmts(true); setSelectedPatientDetails(params.row) }}>
                                        <img style={{ width: '.9vw', height: '.9vw' }} src={ImagePaths.Comments.default} alt={"Add Comments"} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            {waitingCmts ? renderWaitingCmt(params.row) : []}
                        </Box>
                    )
                }
            },
            {
                field: 'doctor_name', headerName: 'Consultant Name', flex: 0.11,
                renderCell: (params) => {
                    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box>{params?.row?.doctor_name.length > 15 ?
                                <Tooltip title={params?.row?.doctor_name} placement='top' arrow>
                                    <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.doctor_name.slice(0, 15) + '...'}</Typography>
                                </Tooltip> :
                                <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.doctor_name}</Typography>
                            }
                            </Box>
                            {(UserData?.service_type === 'OPTOMETRY' && params?.row?.is_redo_optometry) ? <Box>
                                <Tooltip title={'Optometry Check'} placement='top' arrow>
                                    <Box component={'img'} src={ImagePaths.eyeIcon.default} alt='view' sx={{ height: '1vw', width: '1vw'}}/>
                                </Tooltip>
                            </Box> : null}
                        </Box>
                    )
                }
            },
            {
                field: 'token_number', headerName: 'Token', flex: 0.07,
                renderCell: (params) => {
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box>
                                <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.token_number}</Typography>
                            </Box>
                            <Box>{AppointmentTypeIcon(params?.row?.patient_appointment_types)}</Box>
                        </Box>
                    )
                }
            },
            {
                field: 'waiting_timer', headerName: 'Arrived/Waiting Time', flex: 0.11,
                renderCell: (params) => {
                    return (
                        <Box>
                            {waitTime(params.row, params.row.patient_id)}
                        </Box>
                    )
                }
            },
            {
                field: 'purpose_of_visit', headerName: 'Purpose of Visit', flex: 0.10,
                renderCell: (params) => {
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box>
                                {params?.row?.purpose_of_visit.length > 15 ?
                                    <Tooltip title={params?.row?.purpose_of_visit} placement='top' arrow>
                                        <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.purpose_of_visit.slice(0, 15) + '...'}</Typography>
                                    </Tooltip> :
                                    <Typography sx={{ fontSize: '0.9vw' }}>{params?.row?.purpose_of_visit}</Typography>
                                }
                            </Box>
                            <Box>
                                <Tooltip title={'Edit'} placement='top' arrow>
                                    <IconButton
                                        disabled={params.row.appointment_status === "Cancelled" || getCachevalue('DoctorUserChanged') === 'true' }
                                        onMouseOver={() => { setonChangePov(true) }}
                                        onMouseLeave={() => { setonChangePov(false) }}
                                        onClick={() => { setispovPopOpen(true); setpovText(params.row) }}>
                                        <img style={{ width: '.9vw', height: '.9vw' }} src={ImagePaths.UserEditOn.default} alt={"Add Pov"} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            {waitingCmts ? renderWaitingCmt(params.row) : []}
                        </Box>
                    )
                }
            },
            {
                field: 'opt_dilation',
                headerName: 'Dilation',
                flex: 0.105,
                headerAlign: "center",
                align: "center",
                renderCell: (params) => {
                    const id = params.row.appointment_id;
                    const dilation = params.row.dilation_details?.[0] || {};

                    const isDisable = getCachevalue('DoctorUserChanged') === 'true'

                    const timer = timers[id] || {
                        originalStartTime: dilation.start_time ? new Date(dilation.start_time) : null,
                        endTime: dilation.end_time ? new Date(dilation.end_time) : null,
                        isPaused: dilation.is_paused ?? false,
                        pauseStartTime: dilation.pause_time ? new Date(dilation.pause_time) : null,
                        totalPausedMs: 0,
                        currentTime: new Date(),
                        startTime: dilation.start_time ? new Date(dilation.start_time) : null,
                    };

                    if (timer.originalStartTime) {
                        const pauseResumeLog = dilation.pause_resume_log || [];
                        const totalPausedMs = calculateTotalPausedTime(
                            pauseResumeLog,
                            timer.endTime,
                            timer.isPaused,
                            timer.pauseStartTime
                        );

                        const effectiveStartTime = new Date(timer.originalStartTime.getTime() + totalPausedMs);

                        timer.totalPausedMs = totalPausedMs;
                        timer.startTime = effectiveStartTime;

                        timer.currentTime = timer.endTime
                            ? timer.endTime
                            : (timer.isPaused && timer.pauseStartTime)
                                ? timer.pauseStartTime
                                : new Date();
                    }
                    const updateTimerState = (changes) => {
                        setTimers((prev) => ({
                            ...prev,
                            [id]: {
                                ...prev[id],
                                ...changes,
                            },
                        }));
                    };

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {timer.originalStartTime && (
                                formatTimeDiff(timer.originalStartTime, timer.currentTime, timer.totalPausedMs)
                            )}
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {!timer.startTime && (
                                    <Button
                                        size='small'
                                        variant='outlined'
                                        startIcon={<PlayArrowIcon />}
                                        disabled={params.row.appointment_status !== "Optometry" || isDisable}
                                        onClick={() => {
                                            const now = new Date();
                                            updateTimerState({
                                                startTime: now,
                                                currentTime: now,
                                                endTime: null,
                                                isPaused: false,
                                                pauseStartTime: null,
                                            });
                                            setTimeout(() => {
                                                setTimers((prev) => ({
                                                    ...prev,
                                                    [id]: {
                                                        ...prev[id],
                                                        currentTime: new Date(),
                                                    },
                                                }));
                                            }, 50);
                                            UpdateDilationTime(id, true, false).then((success) => {
                                                if (success) {
                                                    getPatientDetails();
                                                }
                                            });
                                        }}
                                    >
                                        Start
                                    </Button>
                                )}

                                {timer.startTime && !timer.endTime && (
                                    <>
                                        <Tooltip title={timer.isPaused ? "Resume" : "Pause"} arrow>
                                            <IconButton
                                                disabled={isDisable}
                                                onClick={() => {
                                                    if (timer.isPaused) {
                                                        updateTimerState({
                                                            isPaused: false,
                                                            pauseStartTime: null,
                                                            currentTime: new Date(),
                                                        });
                                                        setRefreshCount(prev => prev + 1);
                                                        UpdateDilationTime(id, false, false, false, false, true).then(success => {
                                                            if (success) getPatientDetails();
                                                        });
                                                    } else {
                                                        const pauseNow = new Date();
                                                        updateTimerState({
                                                            isPaused: true,
                                                            pauseStartTime: pauseNow,
                                                        });
                                                        setRefreshCount(prev => prev + 1);
                                                        UpdateDilationTime(id, false, false, true).then(success => {
                                                            if (success) getPatientDetails();
                                                        });
                                                    }
                                                }}
                                                sx={{ p: '2px' }}
                                            >
                                                {timer.isPaused ? (
                                                    <PlayArrowIcon sx={{ fontSize: '1rem' }} />
                                                ) : (
                                                    <PauseIcon sx={{ fontSize: '1rem' }} />
                                                )}
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Reset" arrow>
                                            <IconButton
                                                disabled={isDisable}
                                                onClick={() => {
                                                    UpdateDilationTime(id, false, false, false, true).then((success) => {
                                                        if (success) {
                                                            setTimers(prev => {
                                                                const updated = { ...prev };
                                                                delete updated[id]; // clear timer state for this id
                                                                return updated;
                                                            });
                                                            setRefreshCount(prev => prev + 1); // refresh timers
                                                        }
                                                    });
                                                }}
                                                sx={{ p: '2px' }}
                                            >
                                                <ReplayIcon sx={{ fontSize: '1rem' }} />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Stop" arrow>
                                            <IconButton
                                                disabled={isDisable}
                                                onClick={() => {
                                                    let stopTime;
                                                    let shouldInsertDummyResume = false;

                                                    if (timer.isPaused && timer.pauseStartTime) {
                                                        stopTime = timer.pauseStartTime;
                                                        shouldInsertDummyResume = true;
                                                    } else {
                                                        stopTime = new Date();
                                                    }

                                                    UpdateDilationTime(id, false, true, false, false, false, shouldInsertDummyResume).then(() => {
                                                        updateTimerState({
                                                            endTime: stopTime,
                                                            currentTime: stopTime,
                                                        });
                                                    });
                                                }}
                                                sx={{ p: '2px' }}
                                            >
                                                <StopIcon sx={{ fontSize: '1rem' }} color="error" />
                                            </IconButton>
                                        </Tooltip>
                                    </>
                                )}

                                {timer.endTime && (
                                    <Typography color="green" fontWeight={500} fontSize={'0.9vw'} display="flex" alignItems="center">
                                        <CheckCircleIcon sx={{ fontSize: '1vw', mr: 0.5 }} /> Completed
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    );
                },
            },
            {
                field: 'appointment_status', headerName: 'Status', flex: 0.225, headerAlign: "center", align: "center",
                renderCell: (params) => {
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', visibility:getCachevalue('DoctorUserChanged') === 'true' ? 'hidden' : 'visible' }}>
                            {StatusBtns(params.row, params.row.appointment_id)}
                        </Box>
                    )
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.08, headerAlign: "center", align: "center",
                renderCell: (params) => {
                    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                    let CancelBtn = false
                    let StateDate2 = new Date(datePicker)
                    const isTodayAppointment = DateTime.fromJSDate(StateDate2).toFormat('yyyy-MM-dd') !== DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
                    let CancelStatusList = JSON.parse(localGetItem('cancel_appointment_status')) ? JSON.parse(localGetItem('cancel_appointment_status')) : JSON.parse(localGetItem('loggedInUserInfo'))?.cancel_appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.cancel_appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.cancel_appointment_status : Cancel_appointment_Status_opt : Cancel_appointment_Status_opt
                    if (CancelStatusList?.find((list) => (list?.label === (params?.row?.appointment_status === 'Optometry' ? 'With Optometry' : params?.row?.appointment_status) && list?.is_checked)) || params.row.appointment_status === "Booked" || params.row.appointment_status === "Ip Appointment") {
                        CancelBtn = true
                    }
                    return (
                        getCachevalue('DoctorUserChanged') === 'true' ?
                            ((params?.row?.transfer_appointment || params?.row?.appointment_status == 'Cancelled' || params?.row?.appointment_status === "Completed") || UserData?.service_type === "OPTOMETRY" || isTodayAppointment) ? null :
                                (<div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Tooltip title={'Request Approval'} placement='top' arrow>
                                        <div>
                                            <IconButton
                                                disabled={false}
                                                onClick={() => {
                                                    setRequestApproval(true);
                                                    setSelectedPatientDetails(params.row);
                                                }}
                                            >
                                                <img className='eMed_OP_AptTbl_Status_Icon' src={ImagePaths.DoctorRequestApproval.default} alt='Request Approval' />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </div>) 
                            :
                        (<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly', width: '100%' }}>
                            {UserData?.is_qms_enabled && isTodayDate ?
                                <Tooltip title={'Call Patient'} placement='top' arrow>
                                    <IconButton
                                        disabled={(disableBtn || params?.row?.is_called || (params.row.appointment_status !== "Arrived" && params.row.appointment_status !== "With Nurse"))}
                                        onClick={() => {
                                            setSelectedPatientDetails(params.row)
                                            setdisableBtn(true)
                                            setTimeout(() => {
                                                DocPatientCall(params.row)
                                            }, 1000);
                                        }}>
                                        <img className='eMed_statusIcon' src={(disableBtn || params?.row?.is_called || (params.row.appointment_status !== "Arrived" && params.row.appointment_status !== "With Nurse")) ? ImagePaths.DocCallOffIcon.default : ImagePaths.DocCallOnIcon.default} alt='Call Patient' />
                                    </IconButton>
                                </Tooltip> : null}
                            <Tooltip title={'Cancel Appontment'} placement='top' arrow>
                                <IconButton
                                    disabled={params.row.appointment_status === "Booked" || params.row.appointment_status === "Ip Appointment" || params.row.appointment_status === "Arrived" || CancelBtn ? false : true}
                                    onClick={() => {
                                        setcancelAppointment(true)
                                        setSelectedPatientDetails(params.row)
                                    }}>
                                    <img className='eMed_statusIcon' src={params.row.appointment_status === "Booked" || params.row.appointment_status === "Ip Appointment" || params.row.appointment_status === "Arrived" || CancelBtn ? ImagePaths.CancelAppoinment.default : ImagePaths.CancelAppDisabled.default} alt='Cancel Appointments' />
                                </IconButton>
                            </Tooltip>
                            {renderMenu(params)}
                        </Box>)
                    )
                }
            },
        ]
        return (
            <Box sx={{ height: '74vh', width: '100%', cursor: 'pointer' }}>
                <DataGrid
                    rows={patientData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    sx={{
                        backgroundColor: Colors.white,
                        '& .MuiDataGrid-footerContainer': {
                            minHeight: '40px',
                            height: '40px',
                        },
                        '& .MuiTablePagination-root': {
                            minHeight: '40px',
                        },
                        '& .MuiDataGrid-row.eMed_OP_UmaHome_BgColor': {
                            backgroundColor: '#FFF2E5',
                            transition: 'background-color 0.2s ease',
                        },
                        '& .MuiDataGrid-row.eMed_OP_UmaHome_BgColor:hover': {
                            backgroundColor: '#FFE3CC',
                        },
                    }}
                    components={{
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { 
                        setpageSize(newPageSize)
                        setCachevalue(newPageSize, 'DoctorHomePageSize')
                    }}
                    rowsPerPageOptions={[15, 30, 45]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={loading}
                    density='compact'
                    getRowClassName={(params) => {
                        if (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") {
                            return 'eMed_OP_CancelPatient'
                        }else if(JSON.parse(localGetItem("loggedInUserInfo"))?.module_name === 'Doctor' &&params?.row?.is_optos_completed){
                            return 'eMed_OP_UmaHome_BgColor'
                        } else {
                            return null
                        }
                    }}
                    onCellClick={(params) => {
                        if (params.row.appointment_status !== "Cancelled" && params.row.appointment_status !== "No Show") {
                            routeToDemograhics(params);
                        }
                    }}
                />
            </Box>
        )
    }

    const waitTime = (data, id) => {

        const convertTime12to24 = moment(data.patient_arrived_time, ["h:mm A"]).format("HH:mm");
        var year = moment(new Date(data.appointment_date)).format("LL") + " " + convertTime12to24 + ":00"
        var currnet_date = new Date();
        var arrived_date = new Date(year);
        var res = Math.abs(currnet_date - arrived_date) / 1000;
        var days = Math.floor(res / 86400);
        var hours = Math.floor(res / 3600) % 24;
        var minutes = Math.floor(res / 60) % 60;
        var seconds = res % 60;

        var result = hours + ' Hr ' + minutes + ' Mins.'
        var time = data.patient_arrived_time ? data.appointment_start_time + " / " + (data.waiting_timer ? data.waiting_timer : result) : "-"

        patientData && patientData.length > 0 && (patientData).map((element, index) => {
            if (id === element.patient_id && element.timer != result && element.timer === undefined) {
                patientData[index]["timer"] = result === "NaN Hr NaN Mins." ? "0 Hr 0 Mins." : result
                setPatientData([...patientData])
            }
        })
        const isRedColor = data?.waiting_timer ? data?.waiting_timer?.split(" ")[0] : data?.timer?.split(" ")[0]

        return (
            <div id='eMed_OP_AptTbl_AptText1' style={{ fontSize: '.9vw' }}>
                {`${time.split("|")[0]} `}<span id='eMed_OP_AptTbl_AptText1' style={{ color: isRedColor >= 1 ? 'red' : 'black' }}>{time.split("|")[1]}</span>
            </div>
        )
    }

    const routeToDemograhics = (params, MoveToDocu = false) => {
        if (params?.row?.doctor_id) {
            if (MoveToDocu) {
                setCachevalue(JSON.stringify(params?.row), "DoctorPatientData")
                setCachevalue(JSON.stringify(params?.row), "WaitingPatientData")
                setCachevalue(JSON.stringify(params?.row?.timer), "waitingTime")
                setCachevalue(JSON.stringify(datePicker), 'SelectedDate')
                history.push({ pathname: "/DoctorHome/PatientDocuments" })
                setCachevalue(true, 'updatePatient')
            } else {
                if (params.field === "patient_account_number" || (params.field === "patient_name" && !onAddComment) || (params.field === "purpose_of_visit" && !onChangePov) || params.field === "waiting_timer" || params.field === "token_number") {
                    setCachevalue(JSON.stringify(params?.row), "DoctorPatientData")
                    setCachevalue(JSON.stringify(params?.row), "WaitingPatientData")
                    setCachevalue(JSON.stringify(params?.row?.timer), "waitingTime")
                    setCachevalue(JSON.stringify(datePicker), 'SelectedDate')
                    history.push({ pathname: "/DoctorHome/DoctorNotes" })
                    setCachevalue(true, 'updatePatient')
                }
            }
        } else {
            if (params.field === "patient_account_number" || (params.field === "patient_name" && !onAddComment) || (params.field === "purpose_of_visit" && !onChangePov) || params.field === "waiting_timer" || (params.field === "token_number")) {
                errorMessage("The patient is not assigned to any doctor. Click the Call button to assign.")
            }
        }
    }

    const povPopClose = () => {
        setispovPopOpen(false)
        setpovText({})
        setonChangePov(false)
    }

    const NxtAppiontmentClose = () => {
        setTimeout(() => { setselectedOption(''); }, 1000)
    }
    const NxtAppointmentSuccess = (message) => {
        setselectedOption('')
        setTimeout(() => {
            successMessage(message)
            getPatientDetails()
        }, 1000);
    }

    const renderNxtApointmtPopup = () => {
        const commonProps = {
            PostSuccess: NxtAppointmentSuccess.bind(this),
            NxtAppiontmentClose: NxtAppiontmentClose.bind(this),
            PatientDetails: SelectedPatientDetails,
        };

        switch (selectedOption) {
            case "NextAppointment":
                return <NextAppointments {...commonProps} FromDoctor={true} clinic_id={ClinicID} ScreenName={"NextAppointment"} />;
            case "Reschedule":
                return <NextAppointments {...commonProps} ScreenName={"RescheduleAppiontment"} />;
            case "TransAppoint":
                return <NextAppointments {...commonProps} FromDocTrans={true} clinic_id={ClinicID} ScreenName={"TransAppoint"} AppointmentType={true} />;
            case "PrintDoctorNotes":
                getPatientDoctorNotesPrint();
                break;
            case "PrintPrescription":
                getPatientPrescriptionPrint();
                break;
            case "OpBarcode":
                getPatientOpCardPrint(false);
                break;
            case "OpCard":
                getPatientOpCardPrint(true);
                break;
            case "BillDetails":
                getPatientOpBillDetailPrint();
                break;
            case "PrescriptionTemplate":
                getPatientPresTemplate();
                break;
            case "CommonBarcode":
                getCommonBarCodePrint();
                break;
            case "MedicalRecord":
                getMedicalRecordPrint();
                break;
            case "ChangeTag":
                postChangeTagNormal();
                break;
            case "PatientRemarks":
                setisRemarks(true)
                setselectedOption("")
                setslctMenuOption("")
                setremarkText("")
                break;
            default:
                return null;
        }
        setselectedOption("")
        setslctMenuOption("")
    }

    const postChangeTagNormal = () => {
        try {
            let data = {
                appointment_id: SelectedPatientDetails?.appointment_id,
                is_emergency: false
            }
            RestAPIService.create(data, Serviceurls.FO_IP_OP_PATIENT_TAG_CHANGE_NORMAL)
                .then((response) => {
                    if (response?.data?.status === 'Success') {
                        successMessage(response.data.message)
                        setTimeout(() => {
                            getPatientDetails()
                            setselectedOption("")
                            setslctMenuOption("")
                        }, 1000);
                    }
                }).catch((error) => {
                    setselectedOption("")
                    setslctMenuOption("")
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
            setselectedOption("")
            setslctMenuOption("")
        }
    }

    const getMedicalRecordPrint = () => {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        try {
            RestAPIService.GetWithoutReplica(Serviceurls.Medical_Record_PRINT_CONFIG_PREVIEW + "?appointment_id=" + SelectedPatientDetails?.appointment_id + "&clinic_id=" + (UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : ClinicID)).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            setselectedOption("")
            setslctMenuOption("")
            errorMessage(error.message)
        }
    }

    const getCommonBarCodePrint = () => {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        try {
            RestAPIService.getAll(Serviceurls.COMMON_BARCODE_PRINT + "?patient_id=" + SelectedPatientDetails?.patient_id + "&appointment_id=" + SelectedPatientDetails?.appointment_id + "&clinic_id=" + (UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : ClinicID)).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPatientPresTemplate = () => {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        try {
            let token = tokenNum ? tokenNum : null
            setselectedOption("")
            RestAPIService.getAll(Serviceurls.OP_PRES_TEMPLATE + "?patient_id=" + SelectedPatientDetails?.patient_id +
                "&doctor_id=" + SelectedPatientDetails?.doctor_id + "&appointment_id=" + SelectedPatientDetails?.appointment_id +
                "&token_number=" + token + "&clinic_id=" + (UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : ClinicID))
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    errorMessage(error.response?.data?.message);
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            errorMessage(error.message)
            setselectedOption("")
            setslctMenuOption("")
        }
    }

    const getPatientOpBillDetailPrint = () => {
        try {
            RestAPIService.getAll(Serviceurls.OP_DETAILED_BILL_PRINT + "?appointment_id=" + SelectedPatientDetails?.appointment_id + "&clinic_id=" + ClinicID).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL); setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            errorMessage(error.message)
            setselectedOption("")
            setslctMenuOption("")
        }
    }

    const getPatientOpCardPrint = (barcodeHeader) => {
        try {
            let Url = ""
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            if (UserData?.service_type === "OPTOMETRY") {
                Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + SelectedPatientDetails?.patient_id + "&appointment_id=" + SelectedPatientDetails?.appointment_id + "&clinic_id=" + UserData?.clinic_id
            }
            if (barcodeHeader) {
                Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + SelectedPatientDetails?.patient_id + "&appointment_id=" + SelectedPatientDetails?.appointment_id + "&clinic_id=" + ClinicID + "&header=false"
            } else {
                Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + SelectedPatientDetails?.patient_id + "&appointment_id=" + SelectedPatientDetails?.appointment_id + "&clinic_id=" + ClinicID
            }
            RestAPIService.getAll(Url).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    errorMessage(error.response?.data?.message);
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            setselectedOption("")
            setslctMenuOption("")
            errorMessage(error.message)
        }
    }

    const getPatientPrescriptionPrint = () => {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        try {
            let APIUrl = ""
            if (isOPT || UserData?.service_type === "OPTOMETRY") {
                APIUrl = Serviceurls.OPT_PRESCRIPTION_PRINT + "?appointment_id=" + SelectedPatientDetails?.appointment_id + "&patient_id=" + SelectedPatientDetails?.patient_id + "&doctor_id=" + SelectedPatientDetails?.doctor_id + "&clinic_id=" + ClinicID + "&language=english"
            }
            else {
                APIUrl = Serviceurls.PRINT_PRESCRIPTION + "?appointment_id=" + SelectedPatientDetails?.appointment_id + "&patient_id=" + SelectedPatientDetails?.patient_id + "&doctor_id=" + SelectedPatientDetails?.doctor_id + "&clinic_id=" + ClinicID + "&export_type=pdf"
            }
            setselectedOption("")
            RestAPIService.getAllTwo(APIUrl).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    errorMessage(error.response?.data?.message);
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            errorMessage(error.message)
            setselectedOption("")
            setslctMenuOption("")
        }
    }

    const getPatientDoctorNotesPrint = () => {
        try {
            var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
            let APIUrl = ""
            if (isOPT || myUser?.service_type === 'OPTOMETRY') {
                APIUrl = Serviceurls.NEW_DOC_NOTES_VISIT_REPORT_PRINT + "?appointment_id=" + SelectedPatientDetails?.appointment_id + "&patient_id=" + SelectedPatientDetails?.patient_id + "&doctor_notes=all" + "&doctor_id=" + SelectedPatientDetails?.doctor_id + "&clinic_id=" + ClinicID
            }
            setselectedOption("")
            RestAPIService.getAllPrint(APIUrl).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setselectedOption("")
                    setslctMenuOption("")
                }).catch((error) => {
                    errorMessage(error.response?.data?.message);
                    setselectedOption("")
                    setslctMenuOption("")
                })
        } catch (error) {
            errorMessage(error.message)
            setselectedOption("")
            setslctMenuOption("")
        }
    }

    const renderPatientRemarks = () => {
        return (
            <Dialog
                open={isRemarks}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Box className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
                    <Box>
                        {"Patient Remarks"}
                    </Box>
                    <Box className="eMed_DialogBox_Close">
                        <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { setisRemarks(false); setremarkText(''); }} />
                    </Box>
                </Box>
                <Box>
                    <DialogContent>
                        <TextField
                            sx={{ width: '25vw' }}
                            multiline
                            inputProps={{ maxLength: 1000 }}
                            rows={3}
                            placeholder={"Add Remarks"}
                            variant="outlined"
                            value={remarkText}
                            onChange={(e) => {
                                setremarkText(e.target.value)
                            }} />
                    </DialogContent>
                    <DialogActions id="eMed_DialogBox_Btn">
                        <Button size="small" variant='outlined' id="eMed_Dia_Btn" onClick={() => { setremarkText('') }}>
                            {'Clear'}
                        </Button>
                        <Button size="small" variant='contained' id="eMed_Dia_Btn" onClick={() => { postInternalCmt() }}>
                            {'Add'}
                        </Button>

                    </DialogActions>
                </Box>
            </Dialog>
        )
    }

    const postInternalCmt = () => {
        try {
            let data = {
                "comments": remarkText,
                "appointment_id": SelectedPatientDetails?.appointment_id,
                "patient_id": SelectedPatientDetails?.patient_id
            }
            RestAPIService.create(data, Serviceurls.FO_INTERNAL_CMT)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        setisRemarks(false)
                        getPatientDetails()
                    }
                })
                .catch((e) => {
                    if (e.response.data.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const postPatientStatus = (status, id, comments, time, waitTime, forWaitingTimer, rowData) => {
        try {
            var data = {
                "appointment_id": id,
                "appointment_status": status,
                "for_waiting_time": forWaitingTimer ? true : false,
                "clinic_id": ClinicID,
                ...(status === "Arrived" && {
                    appointment_time: DateTime.fromJSDate(new Date()).toLocaleString(DateTime.TIME_24_WITH_SECONDS)
                })
            }
            if (rowData && !waitTime) {
                const waiting_time = calculateWaitingTime(rowData);
                data["waiting_timer"] = waiting_time || null
            } else {
                data["waiting_timer"] = waitTime ? waitTime : null
            }
            if (waitingCmts) {
                data['waiting_comment'] = comments
            }
            if (cancelAppointment) {
                data['cancel_reason'] = comments.replace(/\s+/g, ' ').trim()
                data['is_transfered'] = false
                data['transfer_doctor_id'] = null
            }
            RestAPIService.create(data, Serviceurls.DOC_APPOINTMENT_STATUS_UPDATE)
                .then(response => {
                    if (response.data.status == "success") {
                        getPatientDetails()
                        setwaitCmtText('')
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handleApprovalConfirm = () => {
        try {
            let data = {
                appointment_id: SelectedPatientDetails?.appointment_id,
                requested_to: SelectedPatientDetails?.doctor_id,
                requested_by: JSON.parse(localGetItem("loggedInUserInfo"))?.doctor_id,
            };

            RestAPIService.create(data, Serviceurls.DOCTOR_REQUST_APPROVAL).
                then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        getPatientDetails();
                        setRequestApproval(false);
                        setSelectedPatientDetails(null);
                    }
                }).catch((e) => {
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                })
        } catch (e) {
            if (e?.response?.data?.status === "fail") {
                errorMessage(e.response.data.message);
            } else {
                errorMessage(e.message);
            }
        }
    };

    const popupClose = () => {
        setwaitingCmts(false)
        setcancelAppointment(false)
        setRequestApproval(false);
    }

    const addCancelComments = (comments) => {
        postPatientStatus('Cancelled', SelectedPatientDetails.appointment_id, comments, SelectedPatientDetails.timer, SelectedPatientDetails?.waiting_timer, false, SelectedPatientDetails)
        setcancelAppointment(false)
    }
    // render(main)
    return (
        <Box component={'div'} sx={{ height: '90vh', backgroundColor: Colors.Background }}>
            <Box component={'div'}>
                <Box sx={{ width: '100%', height: '10vh', backgroundColor: Colors.white, borderBottom: '1px solid rgb(168, 166, 166)' }}>
                    {headerCards()}
                </Box>
                <Box sx={{ width: '100%' }}>
                    {homeTbl()}
                </Box>
            </Box>
            {selectedOption != "" ? renderNxtApointmtPopup() : null}
            {isRemarks ? renderPatientRemarks() : null}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {ispovPopOpen ?
                <PovEditPopup
                    povEditText={povText.purpose_of_visit}
                    povData={povText}
                    getTableData={getPatientDetails.bind(this)}
                    AlertPopupClose={povPopClose.bind(this)}
                    successMsg={successMessage.bind(this)}
                    errorMsg={errorMessage.bind(this)}
                /> : null}
            {cancelAppointment ? <ReasonPopup
                title={"Are you sure? Do you want to cancel the appointment"}
                AlertPopupClose={popupClose.bind(this)}
                label={"Enter the Reason"}
                btntext={'Cancel'}
                btnvarient={'outlined'}
                btncolor={'error'}
                btntext1={'Confirm'}
                btnvarient1={'contained'}
                sendCmt={addCancelComments.bind(this)} /> : null}
            <Dialog
                open={requestApproval}
                onClose={() => setRequestApproval(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Are you sure?</DialogTitle>
                <DialogContent>
                    <Typography>Do you want to create a Transfer Request?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setRequestApproval(false)}
                        variant="outlined"
                        color="inherit"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleApprovalConfirm}
                        variant="contained"
                        style={{ backgroundColor: "#00bfa5", color: "#fff" }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <Drawer
                anchor={'right'}
                open={FilterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
        </Box>
    )
}
